var _dec, _dec2, _dec3, _class, _class2;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { useCurrencyStore, useFacetsStore, useSearchStore, useSearchWizardStore } from '#imports';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { nextBookingContainer } from '~/apps/user-bookings/next-booking/inversify.config';
import { getPendingReviewsMachine } from '~/apps/user-reviews/pending-review/pendingReviewMachine';
import AuthMixin from '~/mixins/AuthMixin';
import ErrorCapture from '~/mixins/ErrorCaptured';
import { isDayPast } from '~/utility/date/relative';
var UserAccountDesktop = (_dec = Component({
  mixins: [ErrorCapture],
  setup() {
    var searchStore = useSearchStore(usePinia());
    var searchWizardStore = useSearchWizardStore(usePinia());
    // setup facet store so facets available to all components
    var facetsStore = useFacetsStore();
    // setup to fetch currencies ASAP
    var currencyStore = useCurrencyStore();
    return {
      currencyStore,
      facetsStore,
      searchStore,
      searchWizardStore
    };
  }
}), _dec2 = Watch('isLoggedIn'), _dec3 = Watch('isLoggedIn'), _dec(_class = (_class2 = class UserAccountDesktop extends Mixins(AuthMixin) {
  constructor() {
    super(...arguments);
    this.nextBooking = null;
    this.pendingReviews = [];
    this.pendingReviewsMachine = null;
  }
  mounted() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this.fetchNextBooking();
      _this.startPendingReviewsMachine();
      return yield Promise.resolve();
    })();
  }
  fetchNextBooking() {
    if (!this.isLoggedIn) {
      this.nextBooking = null;
      return;
    }
    var machine = nextBookingContainer.get('NextBookingMachine');
    machine.onChange(_ref => {
      var {
        booking
      } = _ref;
      if (booking && !this.nextBooking) {
        this.nextBooking = booking;
      }
    }).start();
  }
  fetchPendingReviews() {
    var _this$pendingReviewsM;
    (_this$pendingReviewsM = this.pendingReviewsMachine) === null || _this$pendingReviewsM === void 0 ? void 0 : _this$pendingReviewsM.send('FETCH_PENDING_REVIEW');
  }
  startPendingReviewsMachine() {
    this.pendingReviewsMachine = getPendingReviewsMachine(this.$route.params.lang || 'en-gb').onTransition(_ref2 => {
      var {
        context
      } = _ref2;
      this.pendingReviews = context.reviews;
    }).start();
  }
  get isNextBookingPast() {
    return this.nextBooking ? isDayPast(this.nextBooking.arrive) : false;
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "fetchNextBooking", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "fetchNextBooking"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "fetchPendingReviews", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "fetchPendingReviews"), _class2.prototype)), _class2)) || _class);
export { UserAccountDesktop as default };